<div class="layout-topbar">
    <div class="topbar-left">

        <a tabindex="0" class="show-menu-button" type="button" (click)="onMenuButtonClick()">
            <i class="pi pi-bars"></i>
        </a>
        
        <div app-breadcrumb></div>
        <a routerLink="/">
            <img class="mobile-logo" src="../../../assets/img/necta_logo_solid_orange_name.svg"
                alt="logo" />
        </a>
    </div>

    <div class="topbar-right" style="display: flex; align-items: center;">
        <ul class="topbar-menu">
            <li class="right-sidebar-item flex gap-2">
                <p-button
                    *ngIf="isCancelButtonVisible()" [disabled]="!isDirty()" [icon]="'pi pi-times'" label="Abbrechen" [rounded]="true" styleClass="function-btn" (click)="onCancelButtonClick()">
                </p-button>
                <p-button
                    *ngIf="isButtonVisible()" [disabled]="!isDirty()" [icon]="'pi pi-save'" label="Speichern" [rounded]="true" styleClass="function-btn" (click)="onSaveButtonClick()">
                </p-button>
            </li>
        </ul>
    </div>
</div>